import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Skeleton, useTheme } from "@mui/material";
import { tokens } from "../../theme";

const SkeletonTable = () => {
    const theme = useTheme();
	const colors = tokens(theme.palette.mode);

    return (
        <TableContainer
        sx={{
            marginTop: '20px'
        }}
        >
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell><Skeleton variant="text" width={80} /></TableCell>
                        <TableCell><Skeleton variant="text" width={200} /></TableCell>
                        <TableCell><Skeleton variant="text" width={150} /></TableCell>
                        <TableCell><Skeleton variant="text" width={100} /></TableCell>
                        <TableCell><Skeleton variant="text" width={80} /></TableCell>
                        <TableCell><Skeleton variant="text" width={80} /></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Array.from({ length: 10 }).map((_, index) => (
                        <TableRow key={index}
                        sx={{
                            backgroundColor: index % 2 === 0 && colors.pink[700]
                        }}
                        >
                            <TableCell><Skeleton variant="rectangular" width={30} height={30} /></TableCell>
                            <TableCell><Skeleton variant="text" width={200} /></TableCell>
                            <TableCell><Skeleton variant="text" width={150} /></TableCell>
                            <TableCell><Skeleton variant="rectangular" width={30} height={30} /></TableCell>
                            <TableCell><Skeleton variant="text" width={80} /></TableCell>
                            <TableCell><Skeleton variant="text" width={80} /></TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default SkeletonTable;